export default "__VITE_ASSET__59NgOXfL__"